import { Component } from "@angular/core";
import { MsalService } from "@azure/msal-angular";

@Component({
  selector: "db-user-menu",
  templateUrl: "./user-menu.component.html",
  styleUrls: ["./user-menu.component.scss"]
})
export class UserMenuComponent {

  constructor(
    private authService: MsalService,
  ) {}

  logout() {
    this.authService.logoutRedirect();
  }
}
